/**
 * Centralized branding constants for AINI
 * Change these values to update branding across the entire application
 */
export const BRAND = {
  name: "AINI",
  fullName: "AI-Integrated Natural Intelligence",
  domain: "aini.ai",
  privacyEmail: "privacy@aini.ai",
} as const;
